import { takeEvery } from 'redux-saga/effects';
import { Action } from 'redux-actions';
import sagaUtility from '../../blocks/utils/saga-utility';
import BusinessSplaceService from '../../services/business-space.service';
import { GetSellingSpotsActionTypes } from './types';
import { getSellingSpotsActions } from './actions';

export default function* sellingSaga() {
    yield takeEvery(GetSellingSpotsActionTypes.REQUEST, getSellingSpotsRequest);
}

function* getSellingSpotsRequest(action: Action<any>) {
    yield sagaUtility(action.payload, BusinessSplaceService.get, getSellingSpotsActions.success, getSellingSpotsActions.failure);
}
